import { t as gsapWithCSS } from "@theme/gsap";
//#region frontend/islands/counter-animation.js
var CounterAnimation = class extends window.HTMLElement {
	connectedCallback() {
		const el = this.querySelector("p");
		const raw = el.textContent ?? "";
		const number = raw.replace(/[^\d,.]/g, "").trim();
		const suffix = raw.replace(/[\d,.]/g, "").trim();
		const obj = { val: 0 };
		this._observer = new IntersectionObserver((entries) => {
			if (!entries[0].isIntersecting) return;
			this._observer.disconnect();
			this._tween = gsapWithCSS.to(obj, {
				val: parseInt(number),
				duration: 1.2,
				ease: "linear",
				onUpdate: () => {
					el.textContent = Math.round(obj.val).toLocaleString() + suffix;
				}
			});
		}, { rootMargin: "0px 0px -5% 0px" });
		this._observer.observe(el);
	}
	disconnectedCallback() {
		this._observer?.disconnect();
		this._tween?.kill();
	}
};
customElements.define("counter-animation", CounterAnimation);
//#endregion
